import classNames from "classnames";
import { ReactNode } from "react";

export function Info({
  info,
  displayInfo = true,
  id,
}: {
  info?: string | ReactNode;
  displayInfo?: boolean;
  id?: string;
}) {
  return (
    <div
      id={id}
      className={classNames("text-sm bg-surface p-2 my-2 rounded", {
        hidden: !info || !displayInfo,
      })}
    >
      {info}
    </div>
  );
}
